import React from "react";
import Layout from '../components/layout/Layout';

const Physicians = () => {
  return (
    <Layout>
      <div className="container py-5">
        <h2 className="text-center mb-4">Meet Our Physicians</h2>
        <div className="row g-4">

          {/* Dr. Sarah Williams */}
          <div className="col-md-4">
            <div className="card shadow-sm h-100">
              <img
                src="https://img.freepik.com/free-photo/doctor-with-white-robe-stethoscope_144627-43879.jpg"
                alt="Dr. Sarah Williams"
                className="card-img-top"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Sarah Williams</h5>
                <p className="card-text">MD, Psychiatry – Specializes in depression, anxiety & mood disorders.</p>
                <a href="/appointments" className="btn btn-outline-primary w-100">Book Now</a>
              </div>
            </div>
          </div>

          {/* Dr. Michael Chen */}
          <div className="col-md-4">
            <div className="card shadow-sm h-100">
              <img
                src="https://img.freepik.com/free-photo/portrait-male-doctor_23-2148480369.jpg?t=st=1744151144~exp=1744154744~hmac=be2ff23982c79bb65054aa1ac3a61cb53fe4513e6d3feb72ae0de0769ea2c64e&w=996"
                alt="Dr. Michael Chen"
                className="card-img-top"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Michael Chen</h5>
                <p className="card-text">PhD, Clinical Psychology – Focus on trauma, PTSD & cognitive behavioral therapy.</p>
                <a href="/appointments" className="btn btn-outline-primary w-100">Book Now</a>
              </div>
            </div>
          </div>

          {/* Dr. Aisha Rahman */}
          <div className="col-md-4">
            <div className="card shadow-sm h-100">
              <img
                src="https://img.freepik.com/free-photo/female-doctor-hospital-with-stethoscope_23-2148827774.jpg?t=st=1744151259~exp=1744154859~hmac=f3a18cd3b987fb0e02c1923d46451d38596e8233097e96b23e06e7fdd4635942&w=1380"
                alt="Dr. Aisha Rahman"
                className="card-img-top"
              />
              <div className="card-body">
                <h5 className="card-title">Dr. Aisha Rahman</h5>
                <p className="card-text">MD, Child & Adolescent Psychiatry – Expert in youth mental health & family counseling.</p>
                <a href="/appointments" className="btn btn-outline-primary w-100">Book Now</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Layout>
  );
};

export default Physicians;
